export default "__VITE_ASSET__DK$OjYHb__"